// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gqFT","colMin":"styles_colMin__ZNrLv"};